import React from 'react';
import { menuData } from '../constants/menu';
import LendoCollapsibleList from './LendoCollapsibleList';
import LendoIcon from './LendoIcon';

const LendoMenuMobile = () => {
  const trackHeaderNavigation = ({
    trackingId,
    url,
    context,
  }: {
    trackingId: string;
    url: string;
    context?: string;
  }) => {
      window.dataLayer.push({
          event: 'elementInteraction',
          elementInfo: {
              group: 'header',
              id: trackingId,
              url: url,
              context: context,
          },
          eventInfo: {
              interaction: 'click',
          },
      })
  };

  return (
    <div className="lendo-menu-mobile">
      {/* Mobile header buttons */}
      <div className="mobile-header-buttons">
        <a
          href="/min-side/logg-inn/"
          className="mobile-header-button"
          onClick={() => {
              trackHeaderNavigation({
                  trackingId: 'Lendo SmartØkonomi',
                  url: '/min-side/logg-inn/',
              })
          }}
        >
          <LendoIcon name="icon/login" size="20px" />
          Lendo SmartØkonomi
        </a>
        <a
          href="/mine-tilbud/"
          className="mobile-header-button"
          onClick={() => {
              trackHeaderNavigation({
                  trackingId: 'Mine tilbud',
                  url: '/mine-tilbud/',
              })
          }}
        >
          Mine tilbud
        </a>
      </div>

      {menuData.mainNav.map((section) => (
        <LendoCollapsibleList key={section.title} title={section.title}>
          <div className="section-links">
            {section.links.map((link) => (
              <div key={link.text} className="link">
                <a href={link.url} className="lendo-link">
                  {link.text}
                </a>
              </div>
            ))}
          </div>
        </LendoCollapsibleList>
      ))}
      {menuData.secondaryNav.map((section) => (
        <div key={section.title} className="lendo-collapsible-list">
            <h3 className="section-title">{section.title}</h3>
            <div className="section-links">
                {section.links.map((link) => (
                <div key={link.text} className="link">
                    <a href={link.url} className="lendo-link">
                    {link.text}
                    </a>
                </div>
                ))}
            </div>
        </div>
      ))}
    </div>
  );
};

export default LendoMenuMobile;
